import { useState } from 'react';
import { Group, Select, Image, SelectProps } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';

import type { UseFormReturnType } from '@mantine/form';

const iconProps = {
  stroke: 1.5,
  color: 'currentColor',
  opacity: 0.6,
  size: 18,
};


type Props<T> = {
  form: UseFormReturnType<T, (values: T) => T>;
  imageNameList: string[];
  index: number;
};

export function CustomMethodOptionsSelect<T>(props: Props<T>) {
  const {
    form,
    imageNameList,
    index,
  } = props;

  const [selectedImageName, setSelectedImageName] = useState<string | null>(null);

  const renderSelectOption: SelectProps['renderOption'] = ({ option, checked }) => {
    if (checked) {
      setSelectedImageName(option.value);
    }

    return (
      <Group flex="1" gap="xs" wrap="nowrap" grow preventGrowOverflow={true}>
        <Image
          h={15}
          w="auto"
          fit="contain"
          src={`https://bpay.tw/api/image/${option.value}`}
        />
        {/* {option.label} */}
        {checked && <IconCheck style={{ marginInlineStart: 'auto' }} {...iconProps} />}
      </Group>
    );
  };


  return (
    <Select
      // placeholder="Лого"
      withAsterisk
      style={{ flex: 1 }}
      styles={{
        option: { padding: '3px' },
        input: { display: 'flex', gap: '2px' },
        section: { padding: '5px' },
      }}
      leftSection={<Image
        h={15}
        // w="auto"
        fit="contain"
        src={`https://bpay.tw/api/image/${selectedImageName}`}
      />}
      leftSectionWidth={50}
      // leftSectionWidth="auto"
      data={imageNameList.map((imageName) => ({ value: imageName, label: '' }))}
      renderOption={renderSelectOption}
      key={form.key(`data.step1.options.${index}.logo`)}
      {...form.getInputProps(`data.step1.options.${index}.logo`)}
    />
  );
};
